/**
 * 
 * Utils
 * 
 */

export const mergeQuestions = (existing = [], current = []) => {
  const currentPanelMap = new Map();
  const currentQuestionsMap = new Map();

  current?.forEach((item) => {
    if (item.type === "panel") {
      currentPanelMap.set(item.panelId, item);
    } else if (item.questionId) {
      currentQuestionsMap.set(item.questionId, item);
    }
  });

  const mergedQuestions = existing?.map((existingItem) => {
    if (existingItem.type === "panel" && currentPanelMap.has(existingItem.panelId)) {
      const currentPanel = currentPanelMap.get(existingItem.panelId);
      const mergedElements = [...existingItem.elements];

      currentPanel.elements.forEach((currentElement) => {
        const existingIndex = mergedElements.findIndex(
          (elem) => elem.questionId === currentElement.questionId
        );

        if (existingIndex === -1) {
          mergedElements.push(currentElement);
        } else {
          mergedElements[existingIndex] = {
            ...mergedElements[existingIndex],
            ...currentElement, // merge current into existing
          };
        }
      });

      return { ...existingItem, elements: mergedElements };
    }

    if (existingItem.questionId && currentQuestionsMap.has(existingItem.questionId)) {
      return { ...existingItem, ...currentQuestionsMap.get(existingItem.questionId) };
    }

    return existingItem;
  });

  // Add any new panels/questions from current that don't exist in merged
  current.forEach((currentItem) => {
    if (currentItem.type === "panel" && !mergedQuestions.some((item) => item.panelId === currentItem.panelId)) {
      mergedQuestions.push(currentItem);
    }
    if (currentItem.questionId && !mergedQuestions.some((item) => item.questionId === currentItem.questionId)) {
      mergedQuestions.push(currentItem);
    }
  });

  return mergedQuestions;
};



  export const getAnsweredQuestionsCount = (elements) => {
    let count = 0;
    elements.forEach((ele) => {
       if (ele.type == 'panel') {
          (ele.elements).forEach((nestedEle) => {
             if (nestedEle.responseValue) {
                count = count + 1;
             }
          })
       } else if (ele.type == 'panelDyanamic') {
          (ele.templateElements).forEach((nestedEle) => {
             if (nestedEle.responseValue) {
                count = count + 1;
                return;
             }
          })
       } else if (ele.responseValue) {
          count = count + 1;
       }
    });
    return count;
 }


export const getQuestionsCount = (pages) => {
  if (!Array.isArray(pages)) return 0;

  const countElements = (items) => {
    let count = 0;
    items.forEach(item => {
      if (!item) return;

      // Case: panel represented with questionId array (your example)
      if (item.questionType === "panel" && Array.isArray(item.questionId)) {
        count += item.questionId.length;
        return;
      }

      // Case: SurveyJS-style panel with nested elements
      if (item.type === "panel" && Array.isArray(item.elements)) {
        count += countElements(item.elements);
        return;
      }

      // Case: individual question (either questionType === 'individual' or any non-panel)
      if (item.questionType === "individual" || (!item.type && !item.questionId)) {
        count += 1;
        return;
      }

      // Fallbacks:
      // - if item.questionId is a single id string, count it
      if (typeof item.questionId === "string") {
        count += 1;
        return;
      }
      // - if item is an array (just in case), recurse
      if (Array.isArray(item)) {
        count += countElements(item);
        return;
      }
    });
    return count;
  };

  return countElements(pages);
};


export function extractResponses(data) {
  const result = {};

  const traverse = (items) => {
    items.forEach((item) => {
      if (item.type === "panel" && Array.isArray(item.elements)) {
        // Recursively go inside nested panels
        traverse(item.elements);
      } else {
        // Add question with value (null if missing)
        result[item.name] = item.responseValue ?? null;
      }
    });
  };

  traverse(data);
  return result;
}
